import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import qs from 'query-string';
import styles from '../index.module.sass';
import OnBoardingLayout from 'layout/onboarding';
import { useAppContext } from 'use-app';
import {
  CHANGE_CC_CVC,
  CHANGE_CC_EXPIRE_DATE,
  CHANGE_CC_NUMBER,
  SHOW_LOADING_COVER,
  useLoginFlowContext,
} from '../use-login-flow';
import amplitude from 'service/amplitude';
import Button from 'components/button';
import { PATH } from 'config';
import BindCardForm from 'module/bind-card-form';

const BindCard = () => {
  const { state, dispatch, bindCardFormButtonRef, bindCard, bindCardSuccess, bindCardFail } = useLoginFlowContext();
  const { state: appState } = useAppContext();
  const history = useHistory();

  useEffect(() => {
    amplitude.bindCard_pageview();
  }, []);

  useEffect(() => {
    if (window.location.hash !== '' && !appState.bindingIsSetted) {
      const data = qs.parse(window.location.hash);
      dispatch({ type: SHOW_LOADING_COVER, payload: true });
      // result 代表這次綁卡成功與否 success: 成功, fail 失敗
      if (data.result === 'success') {
        bindCardSuccess(data['token'], data['merchant_transaction_id'], () =>
          dispatch({ type: SHOW_LOADING_COVER, payload: false })
        );
      } else {
        bindCardFail(data.message, () => dispatch({ type: SHOW_LOADING_COVER, payload: false }));
      }
    }
  }, [appState.bindingIsSetted]); //eslint-disable-line

  const onPass = () => {
    amplitude.bindCard_later_onClick();
    history.replace(PATH.MAIN);
  };

  const onCcNumberFocus = () => amplitude.bindCard_ccNumber_onClick();

  const onCcNumberChange = value =>
    dispatch({
      type: CHANGE_CC_NUMBER,
      payload: value,
    });

  const onCcExpireDateFocus = () => amplitude.bindCard_ccExpireDate_onClick();

  const onCcExpireDateChange = value => {
    dispatch({
      type: CHANGE_CC_EXPIRE_DATE,
      payload: value,
    });
  };

  const onCcCVCFocus = () => amplitude.bindCard_ccCVC_onClick();

  const onCcCVCChange = value => {
    dispatch({
      type: CHANGE_CC_CVC,
      payload: value,
    });
  };

  if (state.loadingCover) {
    return <div className={styles['loading-cover']}>信用卡綁定中</div>;
  }

  return (
    <OnBoardingLayout className={styles['bind-card']}>
      <div className={styles.top}>
        <ul className={styles.progress}>
          <li className={styles.active}>1</li>
          <li className={styles.active}>2</li>
          <li className={styles.active}>3</li>
        </ul>
        <BindCardForm
          ccNumber={state.ccNumber}
          ccNumberErrorMessage={state.ccNumberErrorMessage}
          onCcNumberFocus={onCcNumberFocus}
          onCcNumberChange={onCcNumberChange}
          ccExpireDate={state.ccExpireDate}
          ccExpireDateErrorMessage={state.ccExpireDateErrorMessage}
          onCcExpireDateFocus={onCcExpireDateFocus}
          onCcExpireDateChange={onCcExpireDateChange}
          ccCVC={state.ccCVC}
          ccCVCErrorMessage={state.ccCVCErrorMessage}
          onCcCVCFocus={onCcCVCFocus}
          onCcCVCChange={onCcCVCChange}
          merchantUid={state.merchantUid}
          transactionId={state.transactionId}
          callbackUrl={`https://${window.location.host}${PATH.USER_BIND_CARD}`}
          hiddenFormButtonRef={bindCardFormButtonRef}
        />
      </div>
      <div className={styles.bottom}>
        <Button theme="blue" block={true} loading={state.loading} onClick={bindCard}>
          設定好了
        </Button>
        {state.bindCardFail && (
          <Button theme="link" onClick={onPass}>
            稍後
          </Button>
        )}
      </div>
    </OnBoardingLayout>
  );
};

export default BindCard;
